import React, { useEffect, useState } from 'react';
import dateSetting from '../../../utils/dateSetting';
import { useCookies } from 'react-cookie';
import axios from 'axios';
import _ from 'lodash';
import DefaultLoader from '../../../components/loader/DefaultLoader';

function BatterIndicatorTable({profile, leagueType = 4201}) {
    const [cookies] = useCookies(['hiball_token']);
    let [recordObj, setRecordObj] = useState({});
    let [loading, setLoading] = useState(false);

    useEffect(() => {
        let dateObj = dateSetting();
        let batterIds = profile['playerId'];
        if(leagueType === 4201) {
            let params = {
                recordType: 'digestBattingRecord', recordName: 'selectTrackManRecord',
                batterIds: batterIds,
                seasons: dateObj['season'],
                groupingColumn: 'season',
                gameTypeCode: 4201,
                authToken:JSON.stringify(cookies['hiball_token'])
            }

            axios({
                url : `${process.env.REACT_APP_API_URL}`, params
            }).then((result) => {
                let data = result['data']['result'][0];
                if(data) {
                    data['solidContactRate'] = data['vaildHitRate'];
                    data['flyBallRate'] = (data['flyRate']*1 + data['popUpRate']*1).toFixed(1);
                    setRecordObj(data);
                } else {
                    setRecordObj({});
                }

                setLoading(true);
            });
        } else {
            let params = {
                recordType: 'futuresRecordService', recordName: 'futuresBatterTrackManRecord',
                seasons: dateObj['season'],
                batterIds: batterIds,
                authToken:JSON.stringify(cookies['hiball_token']),
                gameTypeCodes: leagueType
            }

            axios({
                url : `${process.env.REACT_APP_API_URL}`, params
            }).then((result) => {
                let data = result['data']['result'][0];
                if(data) {
                    data['hardHitRate'] = data['hardHit'] ? ((data['hardHit'] / data['inplay'])*100).toFixed(0) : 0;
                    data['barrelRate'] = data['barrel'] ? ((data['barrel'] / data['inplay'])*100).toFixed(0) : 0;
                    data['solidContactRate'] = data['solidContact'] ? ((data['solidContact'] / data['inplay'])*100).toFixed(0) : 0;

                    data['lineDriveRate'] = data['lineDrive'] ? ((data['lineDrive'] / data['inplay'])*100).toFixed(0) : 0;
                    data['totalFlyBall'] = (data['flyBall'] || 0)*1 + (data['popUp'] || 0)*1;
                    data['flyBallRate'] = data['totalFlyBall'] ? ((data['totalFlyBall'] / data['inplay'])*100).toFixed(0) : 0;
                    data['groundBallRate'] = data['groundBall'] ? ((data['groundBall'] / data['inplay'])*100).toFixed(0) : 0;

                    data['hangRate'] = data['hang'] ? ((data['hang'] / data['inplay'])*100).toFixed(0) : 0;
                    data['centerRate'] = data['center'] ? ((data['center'] / data['inplay'])*100).toFixed(0) : 0;
                    data['pushRate'] = data['push'] ? ((data['push'] / data['inplay'])*100).toFixed(0) : 0;
                    setRecordObj(data);
                } else {
                    setRecordObj({});
                }
                
                setLoading(true);
            })
        }
    }, []);

    if(!loading) {
        return <div style={{height: '300px'}}><DefaultLoader/></div>
    }

    return (
    <>
    <div id="batterIndicatorTable">
        <table style={{textAlign:'center', width: '100%'}}>
            <thead>
                <tr>
                    <th>평균타구속도</th>
                    <th>최고타구속도</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{recordObj['avgExitSpeed'] || '-'}</td>
                    <td>{recordObj['maxExitSpeed'] || '-'}</td>
                </tr>
            </tbody>
        </table>
        <table style={{textAlign:'center', width: '100%'}}>
            <thead>
                <tr>
                    <th>강한타구%</th>
                    <th>배럴타구%</th>
                    <th>안타성타구%</th>
                </tr>
            </thead>
            <tbody>
                {
                recordObj ?
                <tr>
                    <td>{recordObj['hardHitRate'] || '-'}</td>
                    <td>{recordObj['barrelRate'] || '-'}</td>
                    <td>{recordObj['solidContactRate'] || '-'}</td>
                </tr>
                :
                <tr>
                    <td></td><td></td><td></td>
                </tr>
                }
                <tr>
                    <th>라이너%</th>
                    <th>뜬공+팝업 %</th>
                    <th>땅볼%</th>
                </tr>
                {
                recordObj ?
                <tr>
                    <td>{recordObj['lineDriveRate'] || '-'}</td>
                    <td>{recordObj['flyBallRate'] || '-'}</td>
                    <td>{recordObj['groundBallRate'] || '-'}</td>
                </tr>
                :
                <tr>
                    <td></td><td></td><td></td>
                </tr>
                }
                <tr>
                    <th>당겨침%</th>
                    <th>가운데%</th>
                    <th>밀어침%</th>
                </tr>
                {
                recordObj ?
                <tr>
                    <td>{recordObj['hangRate'] || '-'}</td>
                    <td>{recordObj['centerRate'] || '-'}</td>
                    <td>{recordObj['pushRate'] || '-'}</td>
                </tr>
                :
                <tr>
                    <td></td><td></td><td></td>
                </tr>
                }
                <tr>
                    <th>스윙%</th>
                    <th>인존스윙%</th>
                    <th>아웃존스윙%</th>
                </tr>
                {
                recordObj ?
                <tr>
                    <td>{recordObj['swingRate'] || '-'}</td>
                    <td>{recordObj['zoneSwingRate'] || '-'}</td>
                    <td>{recordObj['chaseSwingRate'] || '-'}</td>
                </tr>
                :
                <tr>
                    <td></td><td></td><td></td>
                </tr>
                }
                
                <tr>
                    <th>컨택%</th>
                    <th>인존컨택%</th>
                    <th>아웃존컨택%</th>
                </tr>
                {
                recordObj ?
                <tr>
                    <td>{recordObj['contactRate'] || '-'}</td>
                    <td>{recordObj['zoneContactRate'] || '-'}</td>
                    <td>{recordObj['chaseContactRate'] || '-'}</td>
                </tr>
                :
                <tr>
                    <td></td><td></td><td></td>
                </tr>
                }
                
            </tbody>
        </table>
    </div>
    </>
    )
}

export default BatterIndicatorTable;